/* BD RUNTIME v6 - consolidated Bolddesignz custom layer (perf build).
   Loader hydrates window.BD_* synchronously BEFORE the drawer boots.
   Drawer maintained UNMINIFIED: single-row upsell carousel, optimistic
   drawer open on EVERY add path (form submit + YMQ fetch/XHR), trust row.
   [M] modules  [D] cart drawer  [W] watchers  [L] lazy backgrounds  [S] swiper */
/* [M] */
/* ============================================================================
   BD RUNTIME MODULES (steps / sticky buy bar / skeleton / drawer data loader)
   Config injected by layout as window.BD_RT = {steps, bar, cv, tpl}
   Every module is independent, guarded, and no-ops cleanly if its hooks are
   missing. Nothing here moves or mutates YMQ-owned DOM nodes.
   ========================================================================= */
(function () {
  'use strict';
  var doc = document, root = doc.documentElement;
  var RT = window.BD_RT || {};
  var TPL = root.getAttribute('data-template') || '';
  var IS_PRODUCT = TPL === 'product';
  function onReady(fn) {
    if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', fn, { once: true });
    else fn();
  }
  function debounce(fn, w) { var t; return function () { clearTimeout(t); t = setTimeout(fn, w); }; }

  /* --------------------------------------------------------------------
     M1. DRAWER DATA LOADER
     The wheel/semicustom/clothing ID lists render inline in the drawer
     snippet (the drawer captures them ONCE at boot - they must exist before
     bd-runtime evaluates). This loader supplies the expensive late-bound
     data - the plastics catalog (metafield parsing) and the $0 markers -
     via sections/bd-drawer-data.liquid + the Section Rendering API, with a
     sessionStorage cache hydrated synchronously before the drawer boots.
     -------------------------------------------------------------------- */
  (function drawerData() {
    var state = 0; // 0 idle, 1 loading, 2 done
    var KEY = 'bdDrawerDataV3', TTL = 30 * 60 * 1000, retried = false;
    function apply(cfg, from) {
      window.BD_WHEEL_PRODUCT_IDS = cfg.wheel || '';
      window.BD_SEMICUSTOM_PRODUCT_IDS = cfg.semicustom || '';
      window.BD_CLOTHING_PRODUCT_IDS = cfg.clothing || '';
      window.BD_PLASTICS = cfg.plastics || [];
      window.BD_MARKERS = cfg.markers || [];
      state = 2;
      try {
        console.log('[BD-DATA] catalogs ready (' + from + '): wheel=' + String(cfg.wheel || '').split(',').filter(Boolean).length
          + ' semicustom=' + String(cfg.semicustom || '').split(',').filter(Boolean).length
          + ' clothing=' + String(cfg.clothing || '').split(',').filter(Boolean).length
          + ' plastics=' + (cfg.plastics || []).length + ' markers=' + (cfg.markers || []).length);
      } catch (e) {}
      try { doc.dispatchEvent(new CustomEvent('cart:refresh')); } catch (e) {}
    }
    // instant hydrate from session cache - catalogs are ready before any drawer opens
    try {
      var c = JSON.parse(sessionStorage.getItem(KEY) || 'null');
      if (c && c.t && (Date.now() - c.t) < TTL && c.cfg) apply(c.cfg, 'cache');
    } catch (e) {}
    function load() {
      if (state) return;
      state = 1;
      fetch('/?sections=bd-drawer-data', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (j) {
          var html = j && j['bd-drawer-data'];
          var d = doc.createElement('div');
          d.innerHTML = html || '';
          var s = d.querySelector('#bd-drawer-data-json');
          var cfg = null;
          try { cfg = s ? JSON.parse(s.textContent) : null; } catch (e) { cfg = null; }
          if (!cfg) { fail(); return; }
          try { sessionStorage.setItem(KEY, JSON.stringify({ t: Date.now(), cfg: cfg })); } catch (e) {}
          apply(cfg, 'fetch');
        })
        .catch(fail);
    }
    function fail() {
      state = 0;
      try { console.warn('[BD-DATA] catalog fetch failed' + (retried ? ' (gave up)' : ', retrying')); } catch (e) {}
      if (!retried) { retried = true; setTimeout(load, 4000); }
    }
    window.__bdLoadDrawerData = load;
    ['cart:refresh', 'cart:updated', 'cart:build', 'ajaxProduct:added'].forEach(function (ev) {
      doc.addEventListener(ev, load, { passive: true });
    });
    doc.addEventListener('click', function (e) {
      var t = e.target;
      // NOTE: deliberately NOT on the add-to-cart button - the add path stays clean.
      if (t && t.closest && t.closest('.sf-cart-icon, [data-open-cart-drawer], a[href="/cart"], a[href*="/cart?"]')) load();
    }, true);
    // warm early on every page - catalogs are in place long before any cart opens
    onReady(function () {
      if ('requestIdleCallback' in window) requestIdleCallback(load, { timeout: 2500 });
      else setTimeout(load, 1200);
    });
  })();

  /* --------------------------------------------------------------------
     M3. STICKY BUY BAR (reversible: theme setting "bd_buybar_enable")
     Mobile product pages. Mirrors the live price text and forwards taps
     to the REAL add-to-cart button so YMQ validation stays in charge.
     If the real button is inert (options incomplete) we scroll the buyer
     to the form instead of forcing a submit.
     -------------------------------------------------------------------- */
  (function buybar() {
    try { console.log('[BD-RT] config=' + JSON.stringify(RT) + ' tpl=' + TPL + ' w=' + window.innerWidth); } catch (e) {}
    if (!IS_PRODUCT || !RT.bar || window.innerWidth > 749) return;
    onReady(function () {
      var btn = doc.querySelector('form[action*="/cart/add"] button[name="add"]');
      if (!btn) return;
      var priceEl = doc.querySelector('.dgk-price-current') || doc.querySelector('[data-product-price]') || doc.querySelector('.product__price, .sf__main-price');
      root.classList.add('bd-buybar-on');

      var bar = doc.createElement('div');
      bar.className = 'bd-buybar';
      bar.hidden = true;
      bar.innerHTML = '<div class="bd-buybar__meta"><span class="bd-buybar__label">Total</span><span class="bd-buybar__price"></span></div>'
        + '<button type="button" class="bd-buybar__btn">' + ((btn.getAttribute('data-atc-text') || btn.textContent || 'Add to cart').trim() || 'Add to cart') + '</button>';
      doc.body.appendChild(bar);
      var barPrice = bar.querySelector('.bd-buybar__price');

      if (!priceEl) bar.querySelector('.bd-buybar__meta').style.display = 'none';
      function syncPrice() {
        if (priceEl) barPrice.textContent = (priceEl.textContent || '').trim();
      }
      syncPrice();
      if (priceEl && 'MutationObserver' in window) {
        new MutationObserver(syncPrice).observe(priceEl, { childList: true, characterData: true, subtree: true });
      }

      function drawerOpen() {
        return root.classList.contains('bd-cart-open') || doc.body.classList.contains('bd-cart-open');
      }
      var pastForm = false, ticking = false;
      function checkPos() {
        ticking = false;
        var r = btn.getBoundingClientRect();
        pastForm = r.bottom < 0; /* buyer has scrolled past the real button */
        bar.hidden = !pastForm || drawerOpen();
        // Shopify's "You're previewing" toolbar sits fixed at the bottom on
        // unpublished themes - lift the bar above it so previews show it too.
        var pb = doc.getElementById('preview-bar-iframe');
        bar.style.bottom = pb ? (pb.getBoundingClientRect().height || 64) + 'px' : '';
      }
      window.addEventListener('scroll', function () {
        if (!ticking) { ticking = true; requestAnimationFrame(checkPos); }
      }, { passive: true });
      window.addEventListener('resize', function () {
        if (!ticking) { ticking = true; requestAnimationFrame(checkPos); }
      }, { passive: true });
      checkPos();
      ['cart:refresh', 'cart:updated', 'ajaxProduct:added'].forEach(function (ev) {
        doc.addEventListener(ev, function () { setTimeout(checkPos, 80); }, { passive: true });
      });
      if ('MutationObserver' in window) {
        new MutationObserver(function () { bar.hidden = !pastForm || drawerOpen(); })
          .observe(root, { attributes: true, attributeFilter: ['class'] });
      }

      bar.querySelector('.bd-buybar__btn').addEventListener('click', function () {
        if (window.__bdStepsExpandAll) window.__bdStepsExpandAll();
        var cs = getComputedStyle(btn);
        var inert = btn.disabled || cs.pointerEvents === 'none';
        if (inert) {
          (btn.closest('form') || btn).scrollIntoView({ behavior: 'smooth', block: 'center' });
        } else {
          btn.click();
        }
      });
    });
  })();

})();

/* [D] */
! function() {
  "use strict";
  if (!window.__bdCartDrawerV1) {
    window.__bdCartDrawerV1 = !0;
    var t = document.getElementById("bd-cart-root");
    if (t) {
      var e = parseFloat(t.dataset.bdThresholdEur) || 200,
        r = [{
          id: "barends",
          title: "Protect your bike",
          a: ["axle-sliders"],
          b: ["copy-of-bold-supermoto-tie-down-straps"],
          bi: !1
        }, {
          id: "ktm-lights",
          title: "Add a headlight",
          a: ["ktm-restyle-front-kit-front-fender-headlight-plastic"],
          b: ["ktm-led-headlight-1", "ktm-loccis-angel-eye-3-0-rgb-led-headlight-ring-light-copy", "ktm-x-light-v2-stealth", "pthl020"],
          bi: !0
        }, {
          id: "fifty-decal",
          title: "Complete your build",
          a: ["50-50-supermoto-wheel-graphics", "matching-50-50-wheel-graphics", "chrome-50-50-supermoto-wheel-graphics-2-color-wheel-wrap", "hexagon-5050", "spokeless-50-50-supermoto-wheel-graphics-2-color-wheel-wrap"],
          b: ["decal-knife-squeegee-combo"],
          bi: !1
        }, {
          id: "beta-lights",
          title: "Matching headlight plastics",
          a: ["beta-loccis-4-0-hex-beam-rgbw-led-headlight", "beta-loccis-eye-4-0-rgbw-led-headlight", "beta-rgb-angel-eye"],
          b: ["beta-rr-2020-2024-headlight-plastics"],
          bi: !0
        }],
        a = t.dataset.bdTextBefore || "",
        n = t.dataset.bdTextAfter || "",
        i = (t.dataset.bdMoneyFormat || "").replace(/<[^>]*>/g, "").trim(),
        o = String.fromCharCode(123, 123) + "amount" + String.fromCharCode(125, 125),
        d = {
          count: t.querySelector("[data-bd-cart-count]"),
          items: t.querySelector("[data-bd-cart-items]"),
          empty: t.querySelector("[data-bd-cart-empty]"),
          rewards: t.querySelector("[data-bd-rewards]"),
          rewardsMsg: t.querySelector("[data-bd-rewards-message]"),
          rewardsFill: t.querySelector("[data-bd-rewards-fill]"),
          rewardsStep: t.querySelector("[data-bd-rewards-step]"),
          upsells: t.querySelector("[data-bd-upsells]"),
          totals: t.querySelector("[data-bd-cart-totals]"),
          subtotal: t.querySelector("[data-bd-subtotal]"),
          discountRow: t.querySelector("[data-bd-row-discount]"),
          discount: t.querySelector("[data-bd-discount]"),
          totalRow: t.querySelector("[data-bd-row-total]"),
          total: t.querySelector("[data-bd-total]"),
          checkout: t.querySelector("[data-bd-cart-checkout]")
        },
        s = ["KTM", "HUSQVARNA", "YAMAHA", "HONDA", "BETA", "GASGAS", "GAS GAS", "KAWASAKI", "SUZUKI", "FANTIC"],
        l = null,
        c = null,
        u = "",
        p = !1,
        f = {},
        b = 0,
        h = 0,
        m = !1,
        v = null,
        g = 500,
        y = 0,
        w = null,
        _ = ["48t-supermoto-sprocket", "320mm-supermoto-front-brake-kit", "motomaster-x-ring-chain", "rear-brake-disc", "bold-brake-bolts-saljas-som-pack-lagg-in-pris-och-beskrivning-copy"],
        k = ["4x-supermoto-indicators-resistors-complete-set-1", "bold-mini-supermoto-mirrors"],
        S = ["bold-swift-mx-gloves-black-edition", "skoovby-swift-mx-gloves", "bold-swift-mx-gloves-white-edition", "bold-hustler-swift-mx-gloves", "bold-airforce-mx-gloves-original"],
        x = ["bpwb-slipstream-windbreaker-red", "bpwb-slipstream-windbreaker-purple", "bpwb-slipstream-windbreaker-baby-blue", "bold-slipstream-windbreaker-original", "bold-slipstream-windbreaker-original-copy"],
        q = ut(window.BD_WHEEL_PRODUCT_IDS),
        C = ut(window.BD_SEMICUSTOM_PRODUCT_IDS),
        A = ut(window.BD_CLOTHING_PRODUCT_IDS),
        O = {},
        M = "320mm-supermoto-front-brake-kit",
        L = null,
        D = 0;
      window.BDCart = {
          open: Ot,
          close: Mt,
          refresh: tt,
          ticketMath: ticketMath,
          ticketsFrom: function() {
            var c = l || {};
            return ticketMath(c.total_price || 0, cartCurrency(c)).tickets
          },
          get state() {
            return l
          }
        }, window.BDMarkerDebug = function() {
          var t = W(),
            e = {
              markers: window.BD_MARKERS || null,
              resolvedCount: t.length,
              markerQtyInCart: J(),
              lines: []
            };
          l && l.items && l.items.forEach(function(r) {
            var a = [];
            t.forEach(function(t) {
              X(r, t) && a.push(t.matchKey + " : " + t.matchValue)
            }), e.lines.push({
              title: r.product_title,
              product_id: r.product_id,
              variant_id: r.id,
              qty: r.quantity,
              isMarker: Y(r),
              matchesMarkerProps: a,
              properties: r.properties
            })
          });
          try {
            console.log("[BD Marker Debug]", e)
          } catch (t) {}
          return e
        },
        function() {
          function t() {}

          function e(e) {
            return new Proxy(e, {
              get: function(e, r) {
                return r in e ? e[r] : t
              }
            })
          }
          window.ymqCart || (window.ymqCart = e({
            slid: e({
              activeId: "bd-cart-drawer",
              open: function() {
                Ot()
              },
              close: function() {
                Mt()
              }
            }),
            open: function() {
              Ot()
            },
            cartPrice: t
          })), "function" != typeof window.afterValidateBundleVariant && (window.afterValidateBundleVariant = function() {
            nt(!0)
          })
        }(), t.addEventListener("click", function(t) {
          if (t.target.closest("[data-bd-cart-close]")) Mt();
          else if (t.target.closest("[data-bd-cart-checkout]")) window.location.href = "/checkout";
          else {
            var e = t.target.closest("[data-bd-add]");
            if (e) {
              var r = e.closest("[data-bd-card]");
              r && !e.disabled && (a = r.getAttribute("data-bd-variant"), n = r, a && (n && n.classList.add("is-busy"), it(), Lt(function() {
                return E("/cart/add.js", {
                  method: "POST",
                  credentials: "same-origin",
                  headers: {
                    "Content-Type": "application/json",
                    Accept: "application/json"
                  },
                  body: JSON.stringify({
                    id: a,
                    quantity: 1
                  })
                }).then(function(t) {
                  return t.ok ? t.json() : t.json().then(function(t) {
                    throw t
                  })
                }).catch(function(t) {
                  n && n.classList.remove("is-busy");
                  var e = t && (t.description || t.message) || "Could not add to cart.";
                  alert(e)
                })
              })))
            } else {
              var a, n, i = t.target.closest("[data-bd-go]");
              if (i && !t.target.closest("[data-bd-add]") && !t.target.closest("[data-bd-field]")) {
                var o = i.closest("[data-bd-card]"),
                  d = o && o.getAttribute("data-bd-handle");
                if (d) return void(window.location.href = "/products/" + d)
              }
              var s = t.target.closest("[data-bd-block-prev]");
              if (s) { var sp = s.closest(".bd-up-panel"); At(sp && sp.querySelector("[data-bd-block]"), -1); }
              else {
                var l = t.target.closest("[data-bd-block-next]");
                if (l) { var lp = l.closest(".bd-up-panel"); At(lp && lp.querySelector("[data-bd-block]"), 1); }
                else {
                  var c = t.target.closest("[data-bd-qty]"),
                    u = t.target.closest("[data-bd-remove]");
                  if (c || u) {
                    var p = t.target.closest(".bd-cart-item");
                    if (p) {
                      var f = p.getAttribute("data-bd-key"),
                        b = 0;
                      if (c) {
                        var h = p.querySelector("[data-bd-qty-input]"),
                          m = parseInt(h.value, 10) || 0;
                        b = Math.max(0, m + parseInt(c.getAttribute("data-bd-qty"), 10))
                      }
                      Dt(p, f, b)
                    }
                  }
                }
              }
            }
          }
        }), t.addEventListener("change", function(t) {
          var e = t.target.closest("[data-bd-qty-input]");
          if (e) {
            var r = e.closest(".bd-cart-item"),
              a = Math.max(0, parseInt(e.value, 10) || 0);
            Dt(r, r.getAttribute("data-bd-key"), a)
          }
        }), document.addEventListener("keydown", function(e) {
          "Escape" === e.key && t.classList.contains("is-open") && Mt()
        });
      var T = Promise.resolve();
      document.addEventListener("click", function(t) {
        t.target.closest('a[href$="/cart"], a[href*="/cart?"], .sf-cart-icon a, .sf-cart-icon, [data-open-cart-drawer], [data-cart-drawer-toggle], .sf-header__cart, .sf__tooltip-item a[href*="cart"], .mini-cart__trigger') && (/\/cart\/?$/.test(window.location.pathname) || (t.preventDefault(), t.stopPropagation(), Ot(!0)))
      }, !0);
      var E = window.fetch;
      window.fetch = function(t, e) {
        var r = "string" == typeof t ? t : t && t.url || "",
          a = E.apply(this, arguments);
        var W = Et(r) && -1 === r.indexOf("ymq-no-listen") && -1 === r.indexOf("bd-marker") && -1 === r.indexOf("/cart/change") && -1 === r.indexOf("/cart.js");
        return W && Tt(r) && Wt(), W && a.then(function(t) {
          t && t.ok ? nt(Tt(r)) : Tt(r) && Ht(!0)
        }).catch(function() {
          Tt(r) && Ht(!0)
        }), a
      };
      var j = XMLHttpRequest.prototype.open,
        I = XMLHttpRequest.prototype.send;
      XMLHttpRequest.prototype.open = function(t, e) {
        return this.__bdCartUrl = e, j.apply(this, arguments)
      }, XMLHttpRequest.prototype.send = function() {
        var t = this.__bdCartUrl || "";
        if (Et(t) && -1 === t.indexOf("ymq-no-listen") && -1 === t.indexOf("bd-marker") && -1 === t.indexOf("/cart/change") && -1 === t.indexOf("/cart.js")) {
          var e = this;
          Tt(t) && Wt(), this.addEventListener("load", function() {
            e.status >= 200 && e.status < 300 ? nt(Tt(e.__bdCartUrl)) : Tt(e.__bdCartUrl) && Ht(!0)
          }), this.addEventListener("error", function() {
            Tt(e.__bdCartUrl) && Ht(!0)
          })
        }
        return I.apply(this, arguments)
      }, document.addEventListener("submit", function(t) {
        var e = t.target;
        e && e.action && -1 !== e.action.indexOf("/cart/add") && (e.hasAttribute("data-bd-native-submit") || (t.preventDefault(), t.stopPropagation(), It(e)))
      }, !0);
      var P = HTMLFormElement.prototype.submit;
      HTMLFormElement.prototype.submit = function() {
        if (!this.action || -1 === this.action.indexOf("/cart/add") || this.hasAttribute("data-bd-native-submit")) return P.apply(this, arguments);
        It(this)
      }, ["cart:refresh", "cart:updated", "cart:build"].forEach(function(t) {
        document.addEventListener(t, function() {
          nt(!1)
        })
      }), document.addEventListener("ajaxProduct:added", function() {
        nt(!0)
      });
      var B = t.querySelector("[data-bd-upsells-rows]");
      B && B.addEventListener("scroll", function(t) {
        var e = t.target && t.target.closest ? t.target.closest("[data-bd-block]") : null;
        e && window.requestAnimationFrame(function() {
          var t = e.querySelectorAll(".bd-up-card"),
            r = e.querySelector(".bd-up-block__vp");
          if (t.length && r) {
            for (var a = r.getBoundingClientRect().left, n = 0, i = 1 / 0, o = 0; o < t.length; o++) {
              var d = Math.abs(t[o].getBoundingClientRect().left - a);
              d < i && (i = d, n = o)
            }
            e.__index = n, Ct(e)
          }
        })
      }, !0), "loading" === document.readyState ? document.addEventListener("DOMContentLoaded", tt, {
        once: !0
      }) : tt();
      try {
        console.info("[BD Cart] drawer v30-notickets ready (markers: Regular base + Regular Gloss finish, extensible list; YMQ re-sync)")
      } catch (t) {}
    }
  }

  function R(t, e) {
    var r = "",
      a = /\{\{\s*(\w+)\s*\}\}/,
      n = e || i || o;

    function d(t, e, r, a) {
      if (e = null == e ? 2 : e, r = r || ",", a = a || ".", isNaN(t) || null == t) return 0;
      var n = (t = (t / 100).toFixed(e)).split(".");
      return n[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + r) + (n[1] ? a + n[1] : "")
    }
    switch ((n.match(a) || [])[1]) {
      case "amount":
      default:
        r = d(t, 2);
        break;
      case "amount_no_decimals":
        r = d(t, 0);
        break;
      case "amount_with_comma_separator":
        r = d(t, 2, ".", ",");
        break;
      case "amount_no_decimals_with_comma_separator":
        r = d(t, 0, ".", ",");
        break;
      case "amount_with_apostrophe_separator":
        r = d(t, 2, "'", ".")
    }
    return n.replace(a, r)
  }

  function F(t) {
    var e = ((t = String(t || "").toLowerCase()).match(/\d{4}/g) || []).map(Number);
    if (!e.length) return null;
    var r = (new Date).getFullYear(),
      a = /current|present|nu\b|now|\+|\u2192/.test(t);
    return [Math.min.apply(null, e), a ? Math.max(r + 1, Math.max.apply(null, e)) : Math.max.apply(null, e)]
  }

  function H(t, e) {
    return !!t && !!e && t[0] <= e[1] && e[0] <= t[1]
  }

  function U(t) {
    if (!t || !t.properties) return null;
    var e = "",
      r = "",
      a = "";
    for (var n in t.properties)
      if (Object.prototype.hasOwnProperty.call(t.properties, n) && "_" !== n.charAt(0)) {
        var i = n.toLowerCase(),
          o = t.properties[n];
        null != o && "" !== o && ("bike brand" === i || !e && -1 !== i.indexOf("brand") ? e = o : !r && /model\s*$/.test(i) ? r = o : a || -1 === i.indexOf("year") || (a = o))
      } return e || r || a ? {
      brand: e,
      model: r,
      year: a,
      productId: t.product_id
    } : null
  }

  function N() {
    if (!l || !l.items) return null;
    for (var t = 0; t < l.items.length; t++) {
      var e = U(l.items[t]);
      if (e && e.brand && (e.model || e.year)) return e
    }
    return null
  }

  function K(t) {
    for (var e = String(t || "").toUpperCase().split(/[\s/,]+/).filter(Boolean), r = [], a = [], n = 0; n < e.length; n++) {
      var i = e[n];
      /^\d/.test(i) || ("LC" === i || "T" === i || "2T" === i || "4T" === i ? a.push(i) : r.push(i))
    }
    return {
      fam: r,
      mods: a
    }
  }

  function V(t, e) {
    for (var r = 0; r < t.length; r++)
      for (var a = 0; a < e.length; a++)
        if (t[r] === e[a] || 0 === t[r].indexOf(e[a]) || 0 === e[a].indexOf(t[r])) return !0;
    return !1
  }

  function G(t) {
    if (!(t = String(t || "").trim())) return null;
    var e = F(t);
    if (!e) return null;
    var r = t.match(/^([A-Za-z]+)\s+(.*?)\s*\d{4}/);
    return r ? {
      brand: r[1].toUpperCase(),
      model: r[2].trim(),
      year: e
    } : null
  }

  function $(t) {
    var e = String(t || ""),
      r = e.search(/Applications/i);
    if (-1 === r) return [];
    e = (e = (e = e.slice(r + 12)).split(/Product description|Shipping\s*&\s*Returns|FAST WORLDWIDE|More Info/i)[0]).replace(/^[\s:]+/, "");
    for (var a = s.map(function(t) {
        return t.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")
      }).join("|"), n = new RegExp("\\s*(?=\\b(?:" + a + ")\\b)", "gi"), i = e.split(n), o = [], d = 0; d < i.length; d++) {
      var l = i[d].replace(/[,;]+$/, "").trim();
      l && /\d{4}/.test(l) && o.push(l)
    }
    return o
  }

  function Z(t) {
    b = Date.now() + (t || 900)
  }

  function z() {
    try {
      console.info.apply(console, ["[BD Marker]"].concat([].slice.call(arguments)))
    } catch (t) {}
  }

  function W() {
    return (window.BD_MARKERS || []).filter(function(t) {
      return t && null != t.variantId
    })
  }

  function Q(t, e) {
    return !!t && (null != e.productId && t.product_id == e.productId || null != e.variantId && t.id == e.variantId)
  }

  function Y(t) {
    for (var e = W(), r = 0; r < e.length; r++)
      if (Q(t, e[r])) return !0;
    return !1
  }

  function X(t, e) {
    if (!t || !t.properties) return !1;
    var r = String(e.matchKey || "").toLowerCase(),
      a = String(e.matchValue || "").toLowerCase();
    if (!r || !a) return !1;
    for (var n in t.properties)
      if (Object.prototype.hasOwnProperty.call(t.properties, n) && n.toLowerCase() === r) {
        var i = String(null == t.properties[n] ? "" : t.properties[n]).trim().toLowerCase();
        if (i === a || 0 === i.indexOf(a)) return !0
      } return !1
  }

  function J() {
    if (!l || !l.items) return 0;
    for (var t = 0, e = 0; e < l.items.length; e++) l.items[e] && Y(l.items[e]) && (t += l.items[e].quantity);
    return t
  }

  /* ---------- giveaway tickets ----------
     Campaign rule: €10 spent = 1 ticket. /cart.js total_price is in the
     presentment currency, so non-EUR carts use a FIXED campaign conversion
     (not the live rate) — same table the original system used. Ported
     verbatim from the /giveaway prep drawer (v8). */
  var TICKET_VALUE_BY_CURRENCY = {
    EUR: 10,
    SEK: 115,
    DKK: 75,
    NOK: 115,
    USD: 11,
    GBP: 9
  };
  var bdLastTickets = -1;
  function cartCurrency(c) {
    var cur = (c && (c.currency || c.presentment_currency)) || "";
    if (!cur) {
      try { cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || ""; } catch (e) {}
    }
    return String(cur || "EUR").toUpperCase();
  }
  function ticketMath(totalCents, currency) {
    currency = String(currency || "EUR").toUpperCase();
    var perTicket = TICKET_VALUE_BY_CURRENCY[currency] || TICKET_VALUE_BY_CURRENCY.EUR;
    var centsPerTicket = Math.round(perTicket * 100);
    var cents = Number(totalCents || 0);
    if (cents <= 0 || !centsPerTicket) {
      return { tickets: 0, awayCents: centsPerTicket, centsPerTicket: centsPerTicket, currency: currency };
    }
    var tickets = Math.floor(cents / centsPerTicket);
    var remainder = cents % centsPerTicket;
    return {
      tickets: tickets,
      awayCents: remainder === 0 ? centsPerTicket : centsPerTicket - remainder,
      centsPerTicket: centsPerTicket,
      currency: currency
    };
  }
  function formatAwayMoney(cents, currency) {
    var amount = Number(cents || 0) / 100;
    try {
      var frac = amount < 10 && amount % 1 !== 0 ? 2 : 0;
      return new Intl.NumberFormat(undefined, {
        style: "currency",
        currency: currency || "EUR",
        minimumFractionDigits: frac,
        maximumFractionDigits: frac
      }).format(amount);
    } catch (e) {
      if (String(currency).toUpperCase() === "SEK") return Math.round(amount) + " kr";
      return amount < 10 && amount % 1 !== 0 ? "€" + amount.toFixed(2) : "€" + Math.round(amount);
    }
  }
  /* Paint the in-drawer counter (when the gated markup exists) and ALWAYS
     broadcast bd-cart:updated for the bd-giveaway widgets (marquee bubble,
     kit circle). Element lookups are lazy so the giveaway can be toggled
     off in theme settings without touching this file. */
  function bdPaintTickets(has) {
    try {
      var cart = l || {};
      var tm = ticketMath(cart.total_price || 0, cartCurrency(cart));
      var el = t.querySelector("[data-bd-tickets]");
      if (el) {
        var num = el.querySelector("[data-bd-tickets-number]"),
          word = el.querySelector("[data-bd-tickets-word]"),
          sub = el.querySelector("[data-bd-tickets-sub]"),
          fill = el.querySelector("[data-bd-tickets-fill]");
        el.hidden = !has;
        el.classList.toggle("is-active", tm.tickets > 0);
        if (num) {
          if (bdLastTickets >= 0 && tm.tickets > bdLastTickets) {
            num.classList.remove("is-pop");
            void num.offsetWidth;
            num.classList.add("is-pop");
          }
          num.textContent = String(tm.tickets);
        }
        if (word) word.textContent = 1 === tm.tickets ? "ticket" : "tickets";
        if (fill) {
          var pct = Math.round((tm.centsPerTicket - tm.awayCents) / tm.centsPerTicket * 100);
          fill.style.width = Math.max(0, Math.min(100, pct)) + "%";
        }
        if (sub) sub.textContent = formatAwayMoney(tm.awayCents, tm.currency) + " to your next ticket";
      }
      bdLastTickets = tm.tickets;
      document.dispatchEvent(new CustomEvent("bd-cart:updated", {
        detail: {
          cart: cart,
          tickets: tm.tickets,
          awayCents: tm.awayCents,
          centsPerTicket: tm.centsPerTicket,
          currency: tm.currency
        }
      }));
    } catch (e) {}
  }
  function tt() {
    return fetch("/cart.js?ymq-no-listen=true&t=" + Date.now(), {
      credentials: "same-origin",
      cache: "no-store",
      headers: {
        Accept: "application/json"
      }
    }).then(function(t) {
      return t.json()
    }).then(function(i) {
      var o = function(t) {
        for (var e = t.item_count + "|" + t.total_price + "|" + t.total_discount, r = 0; r < t.items.length; r++) e += "|" + t.items[r].key + ":" + t.items[r].quantity;
        return e
      }(l = i);
      return o !== u && (u = o, function() {
          if (l) {
            var i = l.item_count - J();
            d.count.textContent = i;
            var o = i > 0;
            d.empty.hidden = o, d.rewards.hidden = !o, d.totals.hidden = !o, dt();
            for (var s = "", c = 0; c < l.items.length; c++) !l.items[c] || l.items[c].quantity <= 0 || Y(l.items[c]) || (s += ct(l.items[c]));
            d.items.innerHTML = s;
            var u = function() {
                var t = 1;
                try {
                  window.Shopify && Shopify.currency && Shopify.currency.rate && (t = parseFloat(Shopify.currency.rate) || 1)
                } catch (t) {}
                return Math.round(e * t * 100)
              }(),
              p = l.total_price,
              f = u > 0 ? Math.min(100, p / u * 100) : 100;
            if (d.rewardsFill.style.width = f + "%", d.rewardsStep.classList.toggle("is-done", p >= u), p >= u) d.rewardsMsg.innerHTML = '<span class="bd-cart__check"><svg viewBox="0 0 12 12" fill="none"><path d="M2 6.2 4.8 9 10 3.4" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg></span>' + st(n);
            else {
              var b = R(u - p) || "";
              d.rewardsMsg.innerHTML = st(a).replace("{AMOUNT}", "<strong>" + st(b) + "</strong>")
            }
            d.subtotal.textContent = R(l.original_total_price);
            var h = l.total_discount || 0;
            d.discountRow.hidden = h <= 0, d.totalRow.hidden = h <= 0, h > 0 && (d.discount.textContent = R(h), d.total.textContent = R(l.total_price)), document.querySelectorAll(".sf-cart-count, .cart-count-bubble, [data-cart-count]").forEach(function(t) {
                t.textContent = i
              }),
              bdPaintTickets(o),
              function() {
                if (l)
                  if (l.item_count <= 0) kt();
                  else {
                    var e = t.querySelector("[data-bd-upsells-rows]"),
                      a = t.querySelector("[data-bd-upsells]");
                    if (e && a) {
                      var n = function() {
                        var t = function() {
                            var t = {};
                            if (l && l.items)
                              for (var e = 0; e < l.items.length; e++) l.items[e] && l.items[e].handle && void 0 === t[l.items[e].handle] && (t[l.items[e].handle] = e + 1);
                            return t
                          }(),
                          e = {},
                          a = [];

                        function bdMinIdx(m) {
                          if (!l || !l.items || !m) return 1e9;
                          for (var e = 0; e < l.items.length; e++)
                            if (l.items[e] && m[l.items[e].product_id]) return e + 1;
                          return 1e9
                        }

                        function bdBikeIdx() {
                          if (!l || !l.items) return 1e9;
                          for (var e = 0; e < l.items.length; e++)
                            if (l.items[e] && U(l.items[e])) return e + 1;
                          return 1e9
                        }

                        function n(r, n, i, o, rc) {
                          var d = function(r) {
                            for (var a = [], n = 0; n < r.length; n++) {
                              var i = r[n];
                              !i || t[i] || e[i] || (e[i] = !0, a.push(i))
                            }
                            return a
                          }(i);
                          d.length && a.push({
                            id: r,
                            title: n,
                            handles: d,
                            badges: o || {},
                            rec: rc || 1e9
                          })
                        }
                        pt(q) && n("wheel", "Complete your wheelset", _, 0, bdMinIdx(q));
                        var i = N(),
                          o = function(t) {
                            if (!t) return null;
                            var e = window.BD_PLASTICS || [];
                            if (!e.length) return null;
                            var r = String(t.brand || "").toUpperCase().trim(),
                              a = K(t.model),
                              n = F(t.year);
                            if (!r || !n) return null;
                            for (var i = null, o = -1, d = 0; d < e.length; d++) {
                              for (var s = e[d], l = s.apps ? String(s.apps).split("|") : $(s.desc), c = -1, u = 0; u < l.length; u++) {
                                var p = G(l[u]);
                                if (p && p.brand === r) {
                                  var f = K(p.model);
                                  if (V(a.fam, f.fam) && H(n, p.year)) {
                                    var b = 2;
                                    (-1 !== a.mods.indexOf("LC") || -1 !== a.mods.indexOf("T")) == (-1 !== f.mods.indexOf("LC") || -1 !== f.mods.indexOf("T")) ? b += 1: b -= 2;
                                    var h = p.year[1] - p.year[0];
                                    (b += .1 * Math.max(0, 3 - h)) > c && (c = b)
                                  }
                                }
                              }
                              c > o && (o = c, i = s)
                            }
                            return i && o >= 2 ? i.h : null
                          }(i);
                        if (window.BD_PLASTIC_DEBUG) try {
                          console.info("[BD Upsell] plastics:", (window.BD_PLASTICS || []).length, "| cart product IDs:", (l.items || []).map(function(t) {
                            return t.product_id
                          }), "| semiIDs:", Object.keys(C), "| clothingIDs:", Object.keys(A).length, "| bike:", i, "-> plastic:", o, "| semiCustom?", ft(), "| clothing?", bt())
                        } catch (t) {}
                        var d, s = [];
                        o && s.push(o), i && s.push("decal-knife-squeegee-combo"), ft() && s.push("bold-flag"), n("build", "Complete your build", s, o ? ((d = {})[o] = "Fits your bike", d) : {}, Math.min(bdMinIdx(C), bdBikeIdx()));
                        for (var c = 0; c < r.length; c++) {
                          var u = r[c],
                            p = [];
                          u.a.some(function(e) {
                            return t[e]
                          }) && (p = p.concat(u.b)), u.bi && u.b.some(function(e) {
                            return t[e]
                          }) && (p = p.concat(u.a));
                          var rc2 = 1e9, m2;
                          for (m2 = 0; m2 < u.a.length; m2++) t[u.a[m2]] && t[u.a[m2]] < rc2 && (rc2 = t[u.a[m2]]);
                          if (u.bi)
                            for (m2 = 0; m2 < u.b.length; m2++) t[u.b[m2]] && t[u.b[m2]] < rc2 && (rc2 = t[u.b[m2]]);
                          n(u.id || "rule" + c, u.title || "You might also need", p, 0, rc2)
                        }
                        bt() && (n("gloves", "Add gloves", S, 0, bdMinIdx(A)), n("windbreakers", "Add a windbreaker", x, 0, bdMinIdx(A)));
                        var f = a.reduce(function(t, e) {
                          return t + e.handles.length
                        }, 0);
                        return f < 7 && n("backfill", "Frequently added", k, 0, 1e9), a.sort(function(x, y) {
                          return (x.rec || 1e9) - (y.rec || 1e9)
                        }), a
                      }();
                      if (n.length) {
                        var bdClothingOnly = n.every(function(rr){return rr.id === "gloves" || rr.id === "windbreakers"});
                        var i = [],
                          o = {};
                        var bdRuleRows = 0;
                        n.forEach(function(t) {
                          "backfill" !== t.id && "default" !== t.id && bdRuleRows++
                        });
                        var bdPerRow = bdRuleRows >= 2 ? 3 : 1e9;
                        n.forEach(function(t) {
                          var bdAdded = 0,
                            bdCap = "backfill" === t.id || "default" === t.id ? 1e9 : bdPerRow;
                          t.handles.forEach(function(e) {
                            bdAdded < bdCap && -1 === i.indexOf(e) && (i.push(e), bdAdded++, t.badges[e] && (o[e] = t.badges[e]))
                          })
                        });
                        var d = i.slice(); - 1 !== i.indexOf("320mm-supermoto-front-brake-kit") && d.push("320mm-supermoto-front-braking-disc", "adapter-for-320mm-supermoto-front-braking-disc"), Promise.all(d.map(ht)).then(function() {
                          var t = i.filter(function(t) {
                            var e = O[t];
                            return !!(e && e.variants && e.variants.length) && (!!o[t] || e.variants.some(function(t) {
                              return t.available
                            }))
                          });
                          t.length > 7 && (t = t.slice(0, 7));
                          if (t.length) {
                            for (var r = Math.min(1, t.length), n = [], d = 0; d < r; d++) n.push([]);
                            for (var s = 0; s < t.length; s++) n[s % r].push(t[s]);
                            var bdT = bdClothingOnly ? "Frequently added" : "Complete your build";
                            e.innerHTML = '<div class="bd-up-panel"><div class="bd-up-panel__head"><div class="bd-up-panel__title">' + bdT + '</div><div class="bd-up-panel__nav"><span class="bd-up-panel__count" data-bd-up-count hidden></span><button type="button" class="bd-up-arrow bd-up-arrow--prev" data-bd-block-prev aria-label="Previous" hidden><svg viewBox="0 0 8 14" fill="none"><path d="M7 1 1 7l6 6" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg></button><button type="button" class="bd-up-arrow bd-up-arrow--next" data-bd-block-next aria-label="Next" hidden><svg viewBox="0 0 8 14" fill="none"><path d="m1 1 6 6-6 6" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg></button></div></div><div class="bd-up-panel__body" data-bd-up-body></div></div>';
                            for (var l = e.querySelector("[data-bd-up-body]"), c = 0; c < r; c++) {
                              var u = n[c],
                                p = document.createElement("div");
                              var f = u.length > 1;
                              p.className = "bd-up-block" + (f ? " bd-up-block--multi" : ""), p.setAttribute("data-bd-block", String(c));
                              p.innerHTML = '<div class="bd-up-block__vp"><div class="bd-up-block__track" data-bd-block-track></div></div>', l.appendChild(p);
                              var b = p.querySelector("[data-bd-block-track]");
                              u.forEach(function(t) {
                                var e = mt(t);
                                b.appendChild(e), _t(e, O[t], o[t] || "")
                              }), p.__index = 0, Ct(p)
                            }
                            a.hidden = !1, window.requestAnimationFrame(function() {
                              window.requestAnimationFrame(qt)
                            })
                          } else kt()
                        })
                      } else kt()
                    }
                  }
                else kt()
              }()
          }
        }()),
        function() {
          var t = W();
          if (!t.length) return window.BD_MARKERS && window.BD_MARKERS.some(function(t) {
            return t && null == t.variantId
          }) && z("OFF for one or more markers: variantId missing. Are the marker products Active + published to the Online Store sales channel? Reload the storefront after publishing."), Promise.resolve(!1);
          if (p || !l || !l.items) return Promise.resolve(!1);
          for (var e = 0; e < t.length; e++) {
            var r, a, n = t[e],
              i = null,
              o = !1;
            for (r = 0; r < l.items.length; r++)(a = l.items[r]) && (Q(a, n) ? i = a : X(a, n) && (o = !0));
            i && (f[n.handle] = 0);
            var d = null,
              s = !1;
            if (o && !i) {
              var c = f[n.handle] || 0;
              if (c >= 4) {
                z('"' + n.handle + '": gave up re-adding (never stays / never matches). Check it is $0 + purchasable, or that YMQ is not stripping it.');
                continue
              }
              f[n.handle] = c + 1, s = !0, z(n.matchKey + " : " + n.matchValue + ' detected -> adding "' + n.handle + '" (variant ' + n.variantId + "), try " + f[n.handle]), d = {
                url: "/cart/add.js",
                body: {
                  id: n.variantId,
                  quantity: 1
                }
              }
            } else !o && i ? (z('"' + n.handle + '" no longer needed -> removing'), d = {
              url: "/cart/change.js",
              body: {
                id: i.key,
                quantity: 0
              }
            }) : o && i && 1 !== i.quantity && (d = {
              url: "/cart/change.js",
              body: {
                id: i.key,
                quantity: 1
              }
            });
            if (d) return p = !0, Z(1e3), it(), fetch(d.url + "?bd-marker=1", {
              method: "POST",
              credentials: "same-origin",
              headers: {
                "Content-Type": "application/json",
                Accept: "application/json"
              },
              body: JSON.stringify(d.body)
            }).then(function(t) {
              return t.json().then(function(e) {
                return {
                  ok: t.ok,
                  status: t.status,
                  body: e
                }
              }, function() {
                return {
                  ok: t.ok,
                  status: t.status,
                  body: null
                }
              })
            }).then(function(t) {
              return p = !1, t.ok ? (z("marker " + (s ? "add" : "change") + " OK"), rt(), !0) : (z("marker " + (s ? "ADD" : "CHANGE") + " FAILED (HTTP " + t.status + "): " + (t.body && (t.body.description || t.body.message) || "product not purchasable?")), !0)
            }).catch(function(t) {
              return p = !1, z("marker mutation error", t), !1
            })
          }
          return Promise.resolve(!1)
        }().then(function(t) {
          return t ? tt() : l
        })
    }).catch(function() {})
  }

  function et() {
    return h = Date.now(), m = !0, fetch("/cart.js?bd-ymq-sync=" + Date.now(), {
      credentials: "same-origin",
      cache: "no-store",
      headers: {
        Accept: "application/json"
      }
    }).then(function(t) {
      return t.json()
    }).then(function(t) {
      t && t.items && (l = t)
    }).catch(function() {}).then(function() {
      m = !1
    })
  }

  function rt() {
    var t = Math.max(0, g - (Date.now() - h));
    return m && (t = Math.max(t, 250)), 0 === t ? et() : new Promise(function(e) {
      clearTimeout(v), v = setTimeout(function() {
        et().then(e, e)
      }, t)
    })
  }

  function at() {
    y = Date.now() + 200, ot(), dt()
  }

  function nt(t) {
    it(), clearTimeout(c), c = setTimeout(function() {
      tt().then(function() {
        return Ht(!1), t && Ot(!0), rt()
      }).then(at)
    }, 200)
  }

  function it() {
    y = Math.max(y, Date.now() + 500), dt(), ot()
  }

  function ot() {
    clearTimeout(w), w = setTimeout(dt, Math.max(60, y - Date.now() + 40))
  }

  function dt() {
    if (d.checkout) {
      var t = !!(l && l.item_count - J() > 0);
      d.checkout.disabled = !t || Date.now() < y
    }
  }

  function st(t) {
    return String(null == t ? "" : t).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;")
  }

  function lt(t, e) {
    var r = String(e),
      a = /^https?:\/\//.test(r) ? '<a href="' + st(r) + '" target="_blank" rel="noopener">Uploaded file</a>' : st(r);
    return '<li><span class="bd-cart-item__prop-key">' + st(t) + '</span> : <span class="bd-cart-item__prop-val">' + a + "</span></li>"
  }

  function ct(t) {
    var e = "";
    t.image && (e = -1 !== t.image.indexOf("?") ? t.image.replace("?", "?width=300&height=300&") : t.image + "?width=300&height=300");
    var r = "";
    if (t.properties)
      for (var a in t.properties)
        if (Object.prototype.hasOwnProperty.call(t.properties, a) && "_" !== a.charAt(0)) {
          var n = t.properties[a];
          null !== n && "" !== n && void 0 !== n && (r += lt(a, n))
        } t.variant_title && "Default Title" !== t.variant_title && !r && (r += lt("Option", t.variant_title));
    var i;
    return i = t.original_line_price > t.final_line_price ? "<s>" + R(t.original_line_price) + "</s>" + R(t.final_line_price) : R(t.final_line_price), '<div class="bd-cart-item" data-bd-key="' + st(t.key) + '"><div class="bd-cart-item__image"><a href="' + st(t.url) + '">' + (e ? '<img src="' + st(e) + '" alt="' + st(t.product_title) + '" loading="lazy">' : "") + '</a></div><div class="bd-cart-item__right"><div class="bd-cart-item__top"><h3 class="bd-cart-item__title"><a href="' + st(t.url) + '">' + st(t.product_title) + '</a></h3><button type="button" class="bd-cart-item__remove" data-bd-remove aria-label="Remove"><svg viewBox="0 0 20 20" width="20" height="20" fill="currentColor"><path d="M11.5 8.25a.75.75 0 0 1 .75.75v4.25a.75.75 0 0 1-1.5 0v-4.25a.75.75 0 0 1 .75-.75Z"/><path d="M9.25 9a.75.75 0 0 0-1.5 0v4.25a.75.75 0 0 0 1.5 0v-4.25Z"/><path fill-rule="evenodd" d="M7.25 5.25a2.75 2.75 0 0 1 5.5 0h3a.75.75 0 0 1 0 1.5h-.75v5.45c0 1.68 0 2.52-.327 3.162a3 3 0 0 1-1.311 1.311c-.642.327-1.482.327-3.162.327h-.4c-1.68 0-2.52 0-3.162-.327a3 3 0 0 1-1.311-1.311c-.327-.642-.327-1.482-.327-3.162v-5.45h-.75a.75.75 0 0 1 0-1.5h3Zm1.5 0a1.25 1.25 0 1 1 2.5 0h-2.5Zm-2.25 1.5h7v5.45c0 .865-.001 1.423-.036 1.848-.033.408-.09.559-.128.633a1.5 1.5 0 0 1-.655.655c-.074.038-.225.095-.633.128-.425.035-.983.036-1.848.036h-.4c-.865 0-1.423-.001-1.848-.036-.408-.033-.559-.09-.633-.128a1.5 1.5 0 0 1-.656-.655c-.037-.074-.094-.225-.127-.633-.035-.425-.036-.983-.036-1.848v-5.45Z"/></svg></button></div><ul class="bd-cart-item__props">' + r + '</ul><div class="bd-cart-item__bottom"><div class="bd-cart-qty"><button type="button" data-bd-qty="-1" aria-label="Decrease quantity"><svg width="10" viewBox="0 0 12 2" xmlns="http://www.w3.org/2000/svg"><path d="M11.25 0H.75C.3 0 0 .4 0 1s.3 1 .75 1h10.5c.45 0 .75-.4.75-1s-.3-1-.75-1z" fill="currentColor"/></svg></button><input type="text" inputmode="numeric" value="' + t.quantity + '" data-bd-qty-input aria-label="Quantity"><button type="button" data-bd-qty="1" aria-label="Increase quantity"><svg width="10" viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg"><path d="M11 5H7V1a1 1 0 00-2 0v4H1a1 1 0 000 2h4v4a1 1 0 002 0V7h4a1 1 0 000-2z" fill="currentColor"/></svg></button></div><div class="bd-cart-item__price">' + i + "</div></div></div></div>"
  }

  function ut(t) {
    for (var e = {}, r = (t || "").split(","), a = 0; a < r.length; a++) {
      var n = parseInt(r[a], 10);
      n && (e[n] = !0)
    }
    return e
  }

  function pt(t) {
    if (!l || !l.items) return !1;
    for (var e = 0; e < l.items.length; e++)
      if (l.items[e] && t[l.items[e].product_id]) return !0;
    return !1
  }

  function ft() {
    return pt(C)
  }

  function bt() {
    return pt(A)
  }

  function ht(t) {
    return void 0 !== O[t] ? Promise.resolve(O[t]) : (O[t] = null, E("/products/" + encodeURIComponent(t) + ".js", {
      credentials: "same-origin",
      headers: {
        Accept: "application/json"
      }
    }).then(function(t) {
      return t.ok ? t.json() : null
    }).then(function(e) {
      return O[t] = e || null, O[t]
    }).catch(function() {
      return O[t] = null, null
    }))
  }

  function mt(t) {
    var e = document.createElement("div");
    e.className = "bd-up-card" + (t === M ? " bd-up-card--kit" : ""), e.setAttribute("data-bd-card", ""), e.setAttribute("data-bd-handle", t);
    var r = t === M ? '<div class="bd-up-card__media" data-bd-go><span class="bd-up-card__fit" hidden></span><span class="bd-up-card__kit-imgs"><img class="bd-up-card__kit-img bd-up-card__kit-img--disc" data-bd-disc alt=""><img class="bd-up-card__kit-img bd-up-card__kit-img--adapter" data-bd-adapter alt=""></span></div>' : '<div class="bd-up-card__media" data-bd-go><span class="bd-up-card__fit" hidden></span><img class="bd-up-card__img" data-bd-img alt="" loading="lazy"></div>';
    return e.innerHTML = r + '<div class="bd-up-card__body"><p class="bd-up-card__title" data-bd-go></p><div class="bd-up-card__meta"><span class="bd-up-card__price" data-bd-price></span><span class="bd-up-card__tickets" data-bd-up-tk></span></div><div class="bd-up-card__field" data-bd-field hidden><span class="bd-up-card__swatch" data-bd-swatch hidden></span><select class="bd-up-card__select" data-bd-select></select><svg class="bd-up-card__chevron" viewBox="0 0 10 6" fill="none" aria-hidden="true"><path d="M1 1l4 4 4-4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg></div></div><button type="button" class="bd-up-card__add" data-bd-add><span data-bd-add-label>Add</span></button>', e
  }

  function vt(t, e) {
    if (!t || !t.variants) return "";
    for (var r = String(e || "").toLowerCase().replace(/anodized/g, "").trim(), a = null, n = 0; n < t.variants.length; n++) {
      var i = String(t.variants[n].option1 || t.variants[n].title || "").toLowerCase();
      if (r && (-1 !== i.indexOf(r) || -1 !== r.indexOf(i)) && t.variants[n].featured_image) {
        a = t.variants[n];
        break
      }
    }
    return a && a.featured_image && a.featured_image.src || t.featured_image || t.images && t.images[0] || ""
  }

  function gt(t, e) {
    return t ? -1 !== t.indexOf("?") ? t.replace("?", "?width=" + e + "&") : t + "?width=" + e : ""
  }

  function yt(t, e) {
    var r, a = null;
    if (e)
      for (r = 0; r < t.variants.length; r++)
        if (t.variants[r].id == e) {
          a = t.variants[r];
          break
        } if (!a)
      for (r = 0; r < t.variants.length; r++)
        if (t.variants[r].available) {
          a = t.variants[r];
          break
        } return a || (a = t.variants[0]), a
  }

  function wt(t, e, r) {
    t.setAttribute("data-bd-variant", r.id), t.querySelector("[data-bd-price]").textContent = R(r.price);
    var bdTk = t.querySelector("[data-bd-up-tk]");
    if (bdTk) {
      if (document.getElementById("bd-cart-ticket-counter")) {
        var bdTkN = ticketMath(r.price, cartCurrency(l || {})).tickets;
        bdTk.textContent = bdTkN > 0 ? "+" + bdTkN + " \uD83C\uDF9F\uFE0F" : ""
      } else bdTk.textContent = ""
    }
    if (e.handle === M) {
      var a = O["320mm-supermoto-front-braking-disc"],
        n = O["adapter-for-320mm-supermoto-front-braking-disc"],
        i = String(r.title || "").split("/"),
        o = (i[0] || "").trim(),
        d = (i[1] || i[0] || "").trim(),
        s = t.querySelector("[data-bd-disc]"),
        l = t.querySelector("[data-bd-adapter]");
      s && (s.src = gt(vt(a, o), 160)), l && (l.src = gt(vt(n, d), 140))
    } else {
      var c = r.featured_image && r.featured_image.src || e.featured_image || e.images && e.images[0] || "",
        u = t.querySelector("[data-bd-img]");
      u && c && (u.src = gt(c, 200), u.alt = e.title)
    }
    var p, f, b = t.querySelector("[data-bd-swatch]"),
      h = (p = r.title, (f = String(p || "").toLowerCase()).indexOf("black") > -1 ? "#111827" : f.indexOf("blue") > -1 ? "#2563eb" : f.indexOf("red") > -1 ? "#dc2626" : f.indexOf("orange") > -1 ? "#f97316" : f.indexOf("purple") > -1 ? "#7c3aed" : f.indexOf("pink") > -1 ? "#ec4899" : f.indexOf("gold") > -1 ? "#d4a017" : f.indexOf("green") > -1 ? "#16a34a" : f.indexOf("silver") > -1 ? "#9ca3af" : "");
    h ? (b.style.setProperty("--bd-swatch", h), b.hidden = !1) : b.hidden = !0;
    var m = t.querySelector("[data-bd-add]"),
      v = t.querySelector("[data-bd-add-label]");
    r.available ? (m.disabled = !1, v.textContent = "Add") : (m.disabled = !0, v.textContent = "Sold out")
  }

  function _t(t, e, r) {
    var a = t.querySelector(".bd-up-card__fit");
    r ? (a.textContent = r, a.hidden = !1, t.classList.add("bd-up-card--fit")) : (a.hidden = !0, t.classList.remove("bd-up-card--fit")), t.querySelector(".bd-up-card__title").textContent = e.title;
    var n = t.querySelector("[data-bd-field]"),
      i = t.querySelector("[data-bd-select]"),
      o = e.variants.filter(function(t) {
        return t.available
      }),
      d = o.length ? o : e.variants;
    if (e.variants.length > 1) {
      i.innerHTML = "", d.forEach(function(t) {
        var e = document.createElement("option");
        e.value = t.id, e.textContent = t.title, i.appendChild(e)
      }), n.hidden = !1;
      var s = yt(e, null);
      i.value = s.id, t.__wired || (t.__wired = !0, i.addEventListener("change", function() {
        for (var r = i.value, a = null, n = 0; n < e.variants.length; n++)
          if (e.variants[n].id == r) {
            a = e.variants[n];
            break
          } a && wt(t, e, a)
      })), wt(t, e, s)
    } else n.hidden = !0, wt(t, e, yt(e, null))
  }

  function kt() {
    var e = t.querySelector("[data-bd-upsells]");
    e && (e.hidden = !0)
  }

  function St(t) {
    return Array.prototype.slice.call(t.querySelectorAll(".bd-up-card"))
  }

  function xt(t, e, r) {
    if (!t) return;
    var a = St(t);
    if (a.length) {
      e = Math.max(0, Math.min(a.length - 1, e)), t.__index = e;
      var n = t.querySelector(".bd-up-block__vp");
      if (n && a[e]) {
        var i = a[e].getBoundingClientRect().left - n.getBoundingClientRect().left;
        n.scrollTo({
          left: n.scrollLeft + i,
          behavior: r ? "smooth" : "auto"
        })
      }
      Ct(t)
    }
  }

  function qt() {
    t.querySelectorAll("[data-bd-block]").forEach(function(t) {
      xt(t, "number" == typeof t.__index ? t.__index : 0, !1)
    })
  }

  function Ct(t) {
    var e = St(t),
      p = t.closest(".bd-up-panel"),
      r = p && p.querySelector("[data-bd-block-prev]"),
      a = p && p.querySelector("[data-bd-block-next]"),
      m = e.length > 1;
    if (r && a) {
      var n = t.__index || 0;
      r.disabled = n <= 0, a.disabled = n >= e.length - 1, r.hidden = !m, a.hidden = !m
    }
    if (p) {
      var c = p.querySelector("[data-bd-up-count]");
      if (c) {
        var i = (t.__index || 0) + 1;
        c.textContent = i + " / " + e.length, c.hidden = !m
      }
    }
  }

  function At(t, e) {
    if (t) xt(t, (t.__index || 0) + e, !0)
  }

  function Ot(e) {
    if (!e && t.classList.contains("is-open"));
    else if (!e && Date.now() < b) return;
    Date.now() - D > 800 && (D = Date.now(), tt()), t.classList.add("is-open"), t.setAttribute("aria-hidden", "false"), document.body.classList.add("bd-cart-open"), L = document.activeElement;
    var r = t.querySelector(".bd-cart__close");
    r && r.focus({
      preventScroll: !0
    }), window.requestAnimationFrame(function() {
      window.requestAnimationFrame(qt)
    })
  }

  function Mt() {
    if (t.classList.remove("is-open"), t.setAttribute("aria-hidden", "true"), document.body.classList.remove("bd-cart-open"), L && L.focus) try {
      L.focus({
        preventScroll: !0
      })
    } catch (t) {}
  }

  function Lt(t) {
    return T = T.then(t, t).then(tt, tt).then(rt, rt).then(at, at)
  }

  function Dt(t, e, r) {
    t.classList.add("is-busy"), it(), Lt(function() {
      return fetch("/cart/change.js", {
        method: "POST",
        credentials: "same-origin",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json"
        },
        body: JSON.stringify({
          id: e,
          quantity: r
        })
      })
    })
  }

  function Wt() {
    var r = document.getElementById("bd-cart-root");
    r && r.classList.add("bd-cart--adding"), Ot(!0)
  }

  function Ht(t) {
    var r = document.getElementById("bd-cart-root");
    r && r.classList.remove("bd-cart--adding"), t && Mt()
  }

  function Tt(t) {
    return "string" == typeof t && -1 !== t.indexOf("/cart/add")
  }

  function Et(t) {
    return "string" == typeof t && /\/cart\/(add|change|update|clear)/.test(t)
  }

  function jt(t, e) {
    var r = function(t) {
      return t && t.closest ? t.closest(".product-form") : null
    }(t);
    r && r.classList[e ? "add" : "remove"]("adding")
  }

  function It(t) {
    var e = new FormData(t);
    var root = document.getElementById("bd-cart-root");
    return jt(t, !0), it(), root && root.classList.add("bd-cart--adding"), Ot(!0), Lt(function() {
      return E("/cart/add.js", {
        method: "POST",
        credentials: "same-origin",
        headers: {
          Accept: "application/json"
        },
        body: e
      }).then(function(t) {
        return t.ok ? t.json() : t.json().then(function(t) {
          throw t
        })
      }).then(function() {
        jt(t, !1), root && root.classList.remove("bd-cart--adding"), d.empty && (d.empty.hidden = !0), Ot(!0)
      }).catch(function(e) {
        jt(t, !1), root && root.classList.remove("bd-cart--adding"), Mt();
        var r = e && (e.description || e.message) || "Could not add to cart.";
        alert(r)
      })
    })
  }
}();
/* [W] */
if(document.documentElement.getAttribute('data-template')==='product'){
!function(){if(!window.__bdProductWatchersMergedV1){window.__bdProductWatchersMergedV1=!0,window.__bdDisableMatchingGraphicsTooltip=!0,window.__bdStablePremiumSwatchTooltipV6=!0,window.__bdMobileSwitchPricesV1=!0,"loading"===document.readyState?document.addEventListener("DOMContentLoaded",r,{once:!0}):r(),window.addEventListener("load",function(){r(),setTimeout(r,300),setTimeout(r,900),setTimeout(r,1800)},{once:!0}),"loading"===document.readyState?document.addEventListener("DOMContentLoaded",c,{once:!0}):c(),window.addEventListener("load",function(){c(),setTimeout(c,300),setTimeout(c,900),setTimeout(c,1800)},{once:!0}),document.addEventListener("click",function(t){t.target&&t.target.closest&&t.target.closest('.ymq-options-box[class*="Premium-Base-Image-Swatch"], .ymq-options-box[class*="Premium-Finish-Image-Swatch"]')&&(c(),setTimeout(c,80),setTimeout(c,250))},!0),document.addEventListener("touchstart",function(t){t.target&&t.target.closest&&t.target.closest('.ymq-options-box[class*="Premium-Base-Image-Swatch"], .ymq-options-box[class*="Premium-Finish-Image-Swatch"]')&&(c(),setTimeout(c,80),setTimeout(c,250))},!0);var t=[{selector:'.ymq-options-box[class*="Matching-Helmet-Graphics-switch"]',price:"+ \u20ac99"},{selector:'.ymq-options-box[class*="bd-seatcover-upsell-switch"]',price:"+ \u20ac159"}];if("loading"===document.readyState?document.addEventListener("DOMContentLoaded",function(){s(0),s(300),s(900),s(1800)},{once:!0}):(s(0),s(300),s(900),s(1800)),window.addEventListener("load",function(){s(0),s(600),s(1500)},{once:!0}),"MutationObserver"in window){var e,o,i,n=document.getElementById("MainContent")||document.body;new MutationObserver(function(t){for(var n=!1,s=!1,m=0;m<t.length&&("childList"===t[m].type?n=!0:"attributes"===t[m].type&&(s=!0),!n||!s);m++);n&&(clearTimeout(e),e=setTimeout(r,150),clearTimeout(i),i=setTimeout(a,160)),(n||s)&&(clearTimeout(o),o=setTimeout(c,100))}).observe(n,{childList:!0,subtree:!0,attributes:!0,attributeFilter:["class","ymq-option-tooltip-id","title","data-title","data-tooltip"]})}}function r(){if(!(window.innerWidth>749)){var t=document.querySelector('.ymq-options-box[class*="Matching-Graphics-Image-Swatch"]');t&&t.querySelectorAll(".ymq-option-tooltip").forEach(function(t){t.classList.remove("ymq-option-tooltip"),t.removeAttribute("ymq-option-tooltip-id"),t.removeAttribute("title"),t.removeAttribute("data-title"),t.removeAttribute("data-tooltip")})}}function c(){document.querySelectorAll('.ymq-options-box[class*="Premium-Base-Image-Swatch"], .ymq-options-box[class*="Premium-Finish-Image-Swatch"]').forEach(function(t){t.querySelectorAll(".ymq-option-value-item").forEach(function(t){var e=t.querySelector("input.ymq-option-rc-input"),o=t.querySelector(".ymq-option-swatches-item"),i=t.querySelector(".ymq-option-swatches-image-container");if(e&&o){var n,r,c,a=function(t){return String(t||"").trim()}(e.value);a&&((r="bd-ymq-premium-tooltip",(c=(n=o).querySelector("."+r))||((c=document.createElement("span")).className=r,n.appendChild(c)),c).textContent=a,i&&(i.classList.remove("ymq-option-tooltip"),i.removeAttribute("ymq-option-tooltip-id"),i.removeAttribute("title"),i.removeAttribute("data-title"),i.removeAttribute("data-tooltip"),i.removeAttribute("aria-describedby")))}})}),document.querySelectorAll(".ymq-option-tooltip-box, .ymq-option-tooltip-content, .ymq-option-tooltip-inner, .ymq-tooltip, .ymq-tooltip-content").forEach(function(t){t.remove()})}function a(){/* retired 2026-07-10: the V3 injector in snippets/bd-giveaway.liquid (section 5) owns the helmet/seatcover switch price + ticket badges; this V2 injector raced it and produced duplicate price pills */}function s(t){window.setTimeout(a,t||0)}}();
}
/* [L] */
document.addEventListener('DOMContentLoaded', function(){
        if(!('IntersectionObserver' in window)) return;

        var lazySections = document.querySelectorAll('.lazy-bg');
        if(!lazySections.length) return;

        var observer = new IntersectionObserver(function(entries, obs){
          entries.forEach(function(entry){
            if(!entry.isIntersecting) return;

            var images = entry.target.querySelectorAll('[style*="background-image"]');

            images.forEach(function(el){
              var bg = el.style.backgroundImage;
              if(bg){
                el.style.backgroundImage = bg;
              }
            });

            obs.unobserve(entry.target);
          });
        }, {
          rootMargin:'200px'
        });

        lazySections.forEach(function(section){
          observer.observe(section);
        });
      });
    
/* [S] */
function initSwiper() {
    if (typeof Swiper !== 'undefined') {
      const swiper = new Swiper('.p_slide_parent', {
        direction: 'horizontal',
        loop: true,
        slidesPerView: 1,
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
      });
    } else {
      setTimeout(initSwiper, 100); // Retry every 100ms until Swiper is available
    }
  }
  
  document.addEventListener('DOMContentLoaded', initSwiper);


